import { useEffect, useRef } from 'react';
import {
  resolveApprovalDoc,
  type NextApprovalDoc,
} from '@/components/Approval/@hooks/useNextApprovalDoc';

/** 레거시 조회화면이 "다음 결재 문서 열기"에서 부모로 넘기는 신호 */
export const NEXT_CONFIRM_DOCUMENT_ACTION = 'NEXT_CONFIRM_DOCUMENT';

/**
 * 레거시 iframe 의 "다음 결재 문서 열기" 수신.
 *
 * 레거시는 이동하지 않고 문서 id 만 넘김 — 어느 화면으로 열지는 양식 코드를 조회해 여기서 정함.
 *
 * @param enabled 이 호스트가 레거시 iframe 을 띄우고 있는 동안만 — 켜두면 다른 호스트의
 *   iframe 이 보낸 것까지 받아 엉뚱한 화면이 문서를 바꿔 끼움.
 */
const useLegacyNextDocMessage = (
  enabled: boolean,
  onOpen: (next: NextApprovalDoc) => void,
) => {
  // 리스너는 enabled 로만 재등록 — onOpen 이 매 렌더 새 함수라 deps 에 넣으면 계속 재구독
  const onOpenRef = useRef(onOpen);
  onOpenRef.current = onOpen;

  useEffect(() => {
    if (!enabled) return;

    const handleMessage = (event: MessageEvent) => {
      if (typeof event.data !== 'string') return;

      let parsed;
      try {
        parsed = JSON.parse(event.data);
      } catch {
        return; // 품의와 무관한 문자열 메시지
      }
      if (parsed?.actionType !== NEXT_CONFIRM_DOCUMENT_ACTION || !parsed.docid)
        return;

      void resolveApprovalDoc(String(parsed.docid)).then((next) =>
        onOpenRef.current(next),
      );
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [enabled]);
};

export default useLegacyNextDocMessage;
